export default function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/nonIterableSpread.js
// module id = 884
// module chunks = 0